import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  personalize_page_load:false,
  personalize_meetingData:{},
  personalize_CTAData:{},
  personalize_AnnotationData : {},
  personalize_selectedreviews : {},
  personalize_reviewSource : {},
  personalize_review1Data : {},
  personalize_BuybuttonData : {},
  personalize_linkbtn2Data : {},
  personalize_linkbtn3Data : {},
  personalize_linkbtn4Data : {},
  personalize_linkbtn5Data : {},
  personalize_linkbtn6Data : {},
  personalize_linkbtn7Data : {},
  personalize_linkbtn8Data : {},
  personalize_linkbtn9Data : {},
  personalize_Imgbtn1Data : {},
  personalize_Imgbtn2Data : {},
  personalize_Imgbtn3Data : {},
  personalize_Imgbtn4Data : {},
  personalize_Imgbtn5Data : {},
  personalize_Imgbtn6Data : {},
  personalize_Imgbtn7Data : {},
  personalize_Imgbtn8Data : {},
  personalize_copyPasteData : {},
  personalize_scriptCodeData : {},
  personalize_leadgenFormData : {},
  personalize_leadgen2FormData : {},
  personalize_pollData: {},
  personalize_poll2Data: {},
  personalize_poll3Data: {},
  personalize_opentable1Data: {},
  personalize_brandingData: {},
  personalize_privacyData: {},
  personalize_triggerTime : [],
  personalize_thumbnailmodal : false,
  personalize_overlayTemplateData : [],
  personalize_reports : {}
};

const personalizeSlice = createSlice({
  name: "personalize",
  initialState,
  reducers: {
    resetState(state) {
      state.personalize_page_load = false;
      state.personalize_meetingData = {};
      state.personalize_CTAData = {};
      state.personalize_AnnotationData = {};
      state.personalize_selectedreviews = {};
      state.personalize_reviewSource = {};
      state.personalize_review1Data = {};
      state.personalize_BuybuttonData = {};
      state.personalize_linkbtn2Data = {};
      state.personalize_linkbtn3Data = {};
      state.personalize_linkbtn4Data = {};
      state.personalize_linkbtn5Data = {};
      state.personalize_linkbtn7Data = {};
      state.personalize_linkbtn8Data = {};
      state.personalize_linkbtn9Data = {};
      state.personalize_Imgbtn1Data = {};
      state.personalize_Imgbtn2Data = {};
      state.personalize_Imgbtn3Data = {};
      state.personalize_Imgbtn4Data = {};
      state.personalize_Imgbtn5Data = {};
      state.personalize_Imgbtn6Data = {};
      state.personalize_Imgbtn7Data = {};
      state.personalize_Imgbtn8Data = {};
      state.personalize_copyPasteData = {};
      state.personalize_scriptCodeData = {};
      state.personalize_leadgenFormData = {};
      state.personalize_leadgen2FormData = {};
      state.personalize_pollData = {};
      state.personalize_poll2Data = {};
      state.personalize_poll3Data = {};
      state.personalize_opentable1Data = {};
      state.personalize_brandingData = {};
      state.personalize_privacyData = {};
      state.personalize_triggerTime = [];
      state.personalize_thumbnailmodal = false;
      state.personalize_overlayTemplateData = [];
      state.personalize_emailContacts = [];
    },
    // preState(state, action) {
    //   state.camp_id = action.payload.camp_id;
    // },
    setPersonalizepageLoad(state, action) {
      state.personalize_page_load = action.payload.personalize_page_load;
    },
    setMeetingData(state,action) {
      // console.log(action)
      state.personalize_meetingData = action.payload.personalize_meetingData
    },
    setCTAData(state,action) {
      state.personalize_CTAData =action.payload.personalize_CTAData
    },
    setAnnotationData(state,action) {
      state.personalize_AnnotationData =action.payload.personalize_AnnotationData
    },
    setSelectedreviewsData(state,action) {
      state.personalize_selectedreviews = action.payload.personalize_selectedreviews
      state.personalize_reviewSource = action.payload.personalize_reviewSource
    },
    setReview1Data(state,action) {
      state.personalize_review1Data =action.payload.personalize_review1Data
    },
    setBuybuttonData(state,action) {
      state.personalize_BuybuttonData =action.payload.personalize_BuybuttonData
    },
    setLinkbtn2Data(state,action) {
      state.personalize_linkbtn2Data =action.payload.personalize_linkbtn2Data
    },
    setLinkbtn3Data(state,action) {
      state.personalize_linkbtn3Data =action.payload.personalize_linkbtn3Data
    },
    setLinkbtn4Data(state,action) {
      state.personalize_linkbtn4Data =action.payload.personalize_linkbtn4Data
    },
    setLinkbtn5Data(state,action) {
      state.personalize_linkbtn5Data =action.payload.personalize_linkbtn5Data
    },
    setLinkbtn6Data(state,action) {
      state.personalize_linkbtn6Data =action.payload.personalize_linkbtn6Data
    },
    setLinkbtn7Data(state,action) {
      state.personalize_linkbtn7Data =action.payload.personalize_linkbtn7Data
    },
    setLinkbtn8Data(state,action) {
      state.personalize_linkbtn8Data =action.payload.personalize_linkbtn8Data
    },
    setLinkbtn9Data(state,action) {
      state.personalize_linkbtn9Data =action.payload.personalize_linkbtn9Data
    },
    setImgbtn1Data(state,action) {
      state.personalize_Imgbtn1Data =action.payload.personalize_Imgbtn1Data
    },
    setImgbtn2Data(state,action) {
      state.personalize_Imgbtn2Data =action.payload.personalize_Imgbtn2Data
    },
    setImgbtn3Data(state,action) {
      state.personalize_Imgbtn3Data =action.payload.personalize_Imgbtn3Data
    },
    setImgbtn4Data(state,action) {
      state.personalize_Imgbtn4Data =action.payload.personalize_Imgbtn4Data
    },
    setImgbtn5Data(state,action) {
      state.personalize_Imgbtn5Data =action.payload.personalize_Imgbtn5Data
    },
    setImgbtn6Data(state,action) {
      state.personalize_Imgbtn6Data =action.payload.personalize_Imgbtn6Data
    },
    setImgbtn7Data(state,action) {
      state.personalize_Imgbtn7Data =action.payload.personalize_Imgbtn7Data
    },
    setImgbtn8Data(state,action) {
      state.personalize_Imgbtn8Data =action.payload.personalize_Imgbtn8Data
    },
    setCopyPasteData(state,action) {
      state.personalize_copyPasteData =action.payload.personalize_copyPasteData
    },
    setScript_Code(state,action) {
      state.personalize_scriptCodeData =action.payload.personalize_scriptCodeData
    },
    setLeadgenFormData(state,action){
      state.personalize_leadgenFormData = action.payload.personalize_leadgenFormData
    },
    setLeadgen2FormData(state,action){
      state.personalize_leadgen2FormData = action.payload.personalize_leadgen2FormData
    },
    setPollData(state,action){
      state.personalize_pollData = action.payload.personalize_pollData
    },
    setPoll2Data(state,action){
      state.personalize_poll2Data = action.payload.personalize_poll2Data
    },
    setPoll3Data(state,action){
      state.personalize_poll3Data = action.payload.personalize_poll3Data
    },
    setOpentable1Data(state,action){
      state.personalize_opentable1Data = action.payload.personalize_opentable1Data
    },
    setBrandingData(state,action){
      state.personalize_brandingData = action.payload.personalize_brandingData
    },
    setPrivacyData(state,action){
      state.personalize_privacyData = action.payload.personalize_privacyData
    },
    setTriggerTime(state,action){
      let new_arr = state.personalize_triggerTime;
      // console.log(new_arr)
          new_arr.push(action.payload.personalize_triggerTime)
      // console.log(new_arr)
      state.personalize_triggerTime = new_arr
    },
    setDeleteTriggerTime(state,action){
      let new_arr = state.personalize_triggerTime;
      var filtered = new_arr.filter(function(value){ 
        return value !== action.payload.personalize_triggerTime;
      });
      state.personalize_triggerTime = filtered
    },
    setPersonalizeThumbnailModal(state,action){
      state.personalize_thumbnailmodal = action.payload.personalize_thumbnailmodal
    },
    setOverlayData(state,action){
      // let overlayTemplateData = state.personalize_overlayTemplateData;
      
      //     overlayTemplateData.push(action.payload.overlayData)
      state.personalize_overlayTemplateData = action.payload.overlayData
    },
    setDeleteOverlayData(state,action){
      let overlayTemplateData = state.personalize_overlayTemplateData;
      let personalize_trigger = action.payload.personalize_trigger;
      var pattern  = new RegExp("[^0-9]");
      if(pattern.test(personalize_trigger)){
        // console.log(personalize_trigger,pattern.test(personalize_trigger))
        state.personalize_overlayTemplateData = overlayTemplateData.filter((item)=>item.type !== personalize_trigger)
      }else{
        // console.log(personalize_trigger,pattern.test(personalize_trigger))
        state.personalize_overlayTemplateData = overlayTemplateData.filter((item)=>item.id !== personalize_trigger)
      }
      
    },
    setEmailContacts(state,action){
      state.personalize_emailContacts= action.payload.personalize_emailContacts;
    },
    setReports(state,action){
      state.personalize_reports = action.payload.personalize_reports;
    }

    // makeSingleSlide(state, action) {
    //   state.single_layer = action.payload.single_layer_data;
    // },
  },
});

export const personalizeAction = personalizeSlice.actions;
export default personalizeSlice.reducer;
